import React from 'react';
import { Settings, Shield, Cpu, FileText, Bell, Users, Key, Database, Globe, Zap } from 'lucide-react';
export function ImpostazioniPage() {
  const features = [{
    icon: Shield,
    title: 'Roles & Permissions',
    description: 'Configure user roles and agent access permissions'
  }, {
    icon: Cpu,
    title: 'LLM Providers',
    description: 'Manage API keys and AI provider settings'
  }, {
    icon: FileText,
    title: 'Logging & Audit',
    description: 'Set logging levels and retention policies'
  }, {
    icon: Bell,
    title: 'Notifications',
    description: 'Configure email and webhook notifications'
  }, {
    icon: Users,
    title: 'Team Management',
    description: 'Organize users into teams with shared access'
  }, {
    icon: Key,
    title: 'Authentication',
    description: 'Configure SSO and authentication providers'
  }, {
    icon: Database,
    title: 'Backup & Recovery',
    description: 'Manage automatic backups and recovery'
  }, {
    icon: Globe,
    title: 'Integrations',
    description: 'Connect external services (Slack, Teams, etc.)'
  }, {
    icon: Zap,
    title: 'Automations',
    description: 'Create workflows for recurring actions'
  }, {
    icon: Settings,
    title: 'Advanced',
    description: 'Technical configurations and system parameters'
  }];
  return <div className="max-w-3xl" data-id="element-2376">
      {/* Header */}
      <div className="mb-8" data-id="element-2377">
        <h1 className="text-[20px] font-semibold text-white tracking-tight" data-id="element-2378">
          Settings
        </h1>
        <p className="text-[13px] text-white/40 mt-1" data-id="element-2379">
          Platform configuration and preferences
        </p>
      </div>

      {/* Main Card */}
      <div className="bg-white/[0.02] border border-white/[0.06] rounded-xl p-6" data-id="element-2380">
        {/* Icon */}
        <div className="text-center mb-6" data-id="element-2381">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-white/[0.03] border border-white/[0.06] rounded-xl mb-3" data-id="element-2382">
            <Settings className="w-5 h-5 text-white/30" data-id="element-2383" />
          </div>
          <p className="text-[12px] text-white/30 max-w-md mx-auto" data-id="element-2384">
            Global platform settings will be available here
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-2385">
          {features.map((feature, index) => {
          const Icon = feature.icon;
          return <div key={index} className="flex items-start p-4 bg-white/[0.015] border border-white/[0.04] rounded-xl opacity-50" data-id="element-2386">
                <div className="p-2 bg-white/[0.04] rounded-lg mr-3 flex-shrink-0" data-id="element-2387">
                  <Icon className="w-4 h-4 text-white/25" data-id="element-2388" />
                </div>
                <div className="flex-1 min-w-0" data-id="element-2389">
                  <div className="flex items-center justify-between mb-0.5" data-id="element-2390">
                    <h3 className="text-[12px] font-medium text-white/50 truncate" data-id="element-2391">
                      {feature.title}
                    </h3>
                    <span className="ml-2 px-1.5 py-0.5 bg-white/[0.04] text-white/25 text-[9px] rounded font-medium" data-id="element-2392">
                      Soon
                    </span>
                  </div>
                  <p className="text-[11px] text-white/25 leading-relaxed" data-id="element-2393">
                    {feature.description}
                  </p>
                </div>
              </div>;
        })}
        </div>

        {/* Footer */}
        <div className="mt-6 pt-5 border-t border-white/[0.04] text-center" data-id="element-2394">
          <p className="text-[11px] text-white/20" data-id="element-2395">
            Configuration features coming in future releases
          </p>
        </div>
      </div>
    </div>;
}